<app-base-page pageTitle="Sessions"
	utilityMenuOperationGroupName=""
	operationGroupDisplayName="session actions"
	[operationGroupInitialModel]="pageActions"
	[pageContext]="pageContext"
	(pan)="closeChartTooltips()">

	<div #AdditionalHeaderContent
		additional-header-content>
		<app-information-menu
			[informationMenuItems]="informationMenuItems">
		</app-information-menu>
	</div>

	<div *ngIf="loadingTableDefinitions"
		class="text-center ui-g-12">
		<span class="fa fa-fw fa-spin fa-spinner theme-color double-font-size">
		</span>
	</div>

	<div *ngIf="!loadingTableDefinitions"
		class="ui-g-12 table-container">
		<app-common-table
			[tableDefinitions]="securitySessionsTableDefinitions">
		</app-common-table>
	</div>

</app-base-page>